<template>
  <div>
    <div class="e-card" style="margin-top: 5px">
      <div
        class="e-card-content"
        style="display: grid; grid-template-columns: repeat(4, 1fr); column-gap: 5%"
      >
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="applicationTypesDS"
          placeholder="Permit Type"
          v-model="permitType"
        />
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="dates"
          placeholder="Permit Status"
          v-model="permitStatus"
        />
        <ejs-datepicker
          float-label-type="Always"
          v-model="startDate"
          placeholder="Date From"
          format="dd/MM/yyyy"
        />
        <ejs-datepicker
          float-label-type="Always"
          v-model="endDate"
          placeholder="Date To"
          format="dd/MM/yyyy"
        />
        <div style="width: 2%; padding-top: 4%">
          <ejs-button
            type="button"
            cssClass="e-danger"
            v-on:click.native="onOkButtonClick"
            :disabled="isButtonDisabled"
          >
            Search
          </ejs-button>
        </div>
      </div>
    </div>
    <div style="margin-top: 5px">
      <ejs-grid
        ref="grid"
        :dataSource="reports"
        :allowSorting="true"
        :allowPaging="true"
        :allowTextWrap="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :created="created"
        :toolbarClick="toolbarClick"
        :excelQueryCellInfo="excelQueryCellInfo"
        :allowExcelExport="true"
        height="100%"
        width="100%"
      >
        <e-columns>
          <e-column field="permitNo"
          headerText="Permit Number" textAlign="Left" width="150" />
          <e-column field="permitStatusType"
          headerText="Permit Status" textAlign="Left" width="140" />
          <e-column
            field="eServicesPermitType"
            headerText="Permit Type"
            textAlign="Left"
            width="180"
          />
          <e-column
            field="applicationDate"
            headerText="Application Date"
            type="date"
            :format="gridDateFormat"
            textAlign="Left"
            width="150"
          />
          <e-column
            field="issueDate"
            headerText="Issue Date"
            type="date"
            :format="gridDateFormat"
            textAlign="Left"
            width="140"
          />
          <e-column
            field="vocCompletedDate"
            headerText="VOC Completed Date"
            type="date"
            :format="gridDateFormat"
            textAlign="Left"
            width="150"
          />
          <e-column
            field="siteID"
            headerText="Site Id"
            textAlign="Left"
            width="110"
          />
          <e-column
            field="site_Name"
            headerText="Site Name"
            textAlign="Left"
            width="200"
          />
          <e-column
            field="municipality"
            headerText="Municipality"
            textAlign="Left"
            width="140"
          />
          <e-column
            field="actualInspectionDate"
            headerText="Actual Inspection Date"
            textAlign="Left"
            width="180"
            type="date"
            :format="gridDateFormat"
          />
          <e-column
            field="inspectionStags"
            headerText="Inspection Stags"
            textAlign="Left"
            width="180"
          />
          <e-column
            field="estEndDate"
            headerText="Estimated Completion Date"
            textAlign="Left"
            type="date"
            :format="gridDateFormat"
            width="190"
          />
          <e-column
            field="timeFrme"
            headerText="Time Frme"
            textAlign="Left"
            width="180"
          />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { applicationTypes } from '../services/usercredits-api';
import { getWorkPermitReports } from '../services/site-info-api';
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js'

Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);

export default {
  name: 'WorkPermits',
  data() {
    return {
      permitType: null,
      permitStatus: null,
      startDate: null,
      endDate: null,
      applicationTypesDS: null,
      dates: ['All', 'New Application', 'Pending', 'In Progress', 'Closed'],
      reports: null,
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 10 },
      gridDateFormat : getDataGridDateFormat(),
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
    isButtonDisabled() {
      return !this.permitStatus || !this.permitType;
    },
  },
  async created() {
    await applicationTypes().then((x) => {
      this.applicationTypesDS = x.data.filter((sx) => sx.productType === 'Permit').map((xx) => xx.productName);
      this.applicationTypesDS.unshift('All');
      // this.applicationTypesDS = x.data.map((xx) => xx.productName);
    });
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.grid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async onOkButtonClick() {
      const resp = await getWorkPermitReports(this.permitType, this.permitStatus, this.startDate, this.endDate);
      this.reports = resp.data;
    },
    excelQueryCellInfo(args) {
      switch(args.column.field){
        case 'applicationDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'issueDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'vocCompletedDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'actualInspectionDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'estEndDate':
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.grid.excelExport({
            fileName: reportExportFileName('Work Permit.xlsx'),
          });
          break;
      }
    },
  },
};
</script>
